import { Link, useNavigate } from 'react-router-dom';
import { useGame } from '../context/GameContext.jsx';
import { usePremium } from '../context/PremiumContext.jsx';

export default function CreateGame() {
  const navigate = useNavigate();
  const { updateDraft } = useGame();
  const { premium } = usePremium();

  const pick = (mode) => {
    updateDraft({ mode });
    navigate('/setup');
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <button className="back-btn" onClick={() => navigate(-1)}>←</button>
        <h1>Create</h1>
        <div className="spacer" />
      </div>
      <div className="text-muted" style={{ marginBottom: '1.25rem' }}>
        Two ways to plot your night.
      </div>

      <button className="create-card ai" onClick={() => pick('ai')}>
        <div className="wand-icon">✨</div>
        <div className="badge">{premium ? 'ACTIVE' : 'PREMIUM'}</div>
        <h2>Auto Course</h2>
        <p>
          Drop a city, group size and vibe — we'll find the bars, pick the
          drinks, and chart the walk between holes.
        </p>
        <div className="pills">
          <span className="pill">Real bars</span>
          <span className="pill">Live ratings</span>
          <span className="pill">Walking route</span>
          <span className="pill">Drink pairing</span>
        </div>
        <div className="arrow">→</div>
      </button>

      <button className="create-card custom" onClick={() => pick('custom')}>
        <div className="wand-icon">🛠️</div>
        <div className="badge">FREE</div>
        <h2>Build Your Own</h2>
        <p>
          Hand-pick the bars, write the drink card, set the pars. Full control,
          zero AI.
        </p>
        <div className="pills">
          <span className="pill">Your bars</span>
          <span className="pill">Your drinks</span>
          <span className="pill">Your pars</span>
        </div>
        <div className="arrow">→</div>
      </button>

      <Link to="/join" className="feed-card" style={{ marginTop: '1rem' }}>
        <div className="feed-card-icon">⬚</div>
        <div className="grow">
          <h4>Join instead?</h4>
          <div className="sub">Enter a code or scan QR</div>
        </div>
        <div style={{ color: 'var(--text20)' }}>›</div>
      </Link>
    </div>
  );
}
